import { SxProps } from "@mui/material";

import customScrollbarStyle from "../../constants/CustomScrollbarStyle";
import { theme } from "../../mui-customs/Theme";

export const root: SxProps = {
  position: "relative",
  borderRadius: 2,
  overflow: "hidden",
  backgroundColor: theme.whiteBg.WBG1,
};
export const childrenContainer: SxProps = {
  borderRadius: 2,
  overflowY: "auto",
  padding: { xs: 2.5, sm: 4 },
  minWidth: "300px",
  maxHeight: "80vh",
  mt: { sm: "72px" },

  ...customScrollbarStyle,
};

export const titleContainer: SxProps = {
  display: { xs: "none", md: "flex" },
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: "0",
  left: "0",
  right: "0",
  backgroundColor: "#fff",

  zIndex: "100",
  py: 3,
};

export const closeIcon: SxProps = {
  position: "absolute",
  right: { xs: "10px", md: "30px" },
  display: { xs: "none", md: "block" },
};

export const title: SxProps = {
  color: `${theme.black[800]} !important`,
  width: "fit-content",
};
